export const CUSTOMER_ID = 'CUSTOMER-1234';
export const STRIPE_PUBLIC_KEY = 'STRIPE_PUBLIC_KEY';
export const VENDOR_MERCHANT_ID = 'platform_vendor_merchant_id';
export const VENDOR_SETUP_STRIPE_CLIENT_SECRET =
  'vendor_setup_payment_method_secret';
export const SETUP_PAYMENT_METHOD_POLL_URL =
  'full_url_for_checking_payment_method_status';
export const SETUP_PAYMENT_METHOD_BUTTON_TEXT = 'Save';
export const LEGACY_MF_CARD_WARNING_TITLE =
  'A medication is now required to be associated with a manufacturer copay card in your wallet.';
export const LEGACY_MF_CARD_WARNING_MESSAGE =
  'Select a medication to continue editing this card.';

